import { render, staticRenderFns } from "./redLineIcon.vue?vue&type=template&id=a8373a70&"
import script from "./redLineIcon.vue?vue&type=script&lang=js&"
export * from "./redLineIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports